import React from 'react';
import PropTypes from 'prop-types';
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  Button,
  DrawerFooter
} from '@one-thd/sui-atomic-components';
import { VERBIAGE } from '../utils/consts';
import { GiftCardsCheckBalanceAndReload } from './GiftCardsCheckBalanceAndReload';
import { ReloadSavedGiftCard } from './reload/ReloadSavedGiftCard';

const GiftCardsCheckBalanceAndReloadDrawer = ({ open, position, cardDetail, onCancel }) => {
  return (
    <Drawer
      open={open}
      onClose={() => {
        onCancel();
      }}
      position={position}
    >
      <DrawerHeader title={cardDetail ? 'Reload' : 'Check Balance and Reload'} onClose={onCancel} />
      <DrawerBody>
        {cardDetail ? (
          <ReloadSavedGiftCard
            savedPaymentId={cardDetail?.savedPaymentId}
            cardLast4={cardDetail?.cardLast4}
            onCancel={onCancel}
          />
        ) : (
          <GiftCardsCheckBalanceAndReload isDrawer />
        )}
      </DrawerBody>
      <DrawerFooter class="sui-px-4 sui-pb-1">
        <Button variant="secondary" onClick={onCancel} fullWidth>
          {VERBIAGE.cancel}
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};

GiftCardsCheckBalanceAndReloadDrawer.propTypes = {
  open: PropTypes.bool,
  position: PropTypes.string,
  onCancel: PropTypes.func,
  cardDetail: PropTypes.shape({
    savedPaymentId: PropTypes.string,
    cardLast4: PropTypes.string
  })
};

GiftCardsCheckBalanceAndReloadDrawer.defaultProps = {
  open: false,
  position: 'right',
  onCancel: () => {},
  cardDetail: null
};

export default GiftCardsCheckBalanceAndReloadDrawer;
